<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout align-center justify-center wrap>
      <v-flex xs12 md3>
        <SelectCreditors
          :multiple="false"
          :selected="selectedCreditor"
          :negotiation="true"
          @selectedCreditors="changeSelectCreditors($event)"></SelectCreditors>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field
          class="text-details-none"
          autocomplete="off"
          maxlength="80"
          placeholder="Pesquise por nome ou conteúdo da mensagem"
          @change="searchApproach()"
          v-model="nameFilter"
          value
          box
          label="Pesquisar"
          name="name" />
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          :items="approachsTypes"
          v-model="selectedApproachTypes"
          multiple
          box
          clearable
          label="Tipo"
          class="text-details-none"
          @change="searchApproach">
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" style="padding-right: 5px">{{ item }}</span>
            <span v-if="index === 1" class="grey--text caption"
              >(+{{ selectedApproachTypes.length - 1 }} outros)</span
            >
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 md2>
        <v-switch
          :style="$vuetify.breakpoint.mdAndUp ? 'padding-left: 23%;' : ''"
          @change="searchApproach()"
          v-model="active"
          label="Ativas"></v-switch>
      </v-flex>
      <v-flex xs12 md12>
        <v-data-table
          :headers="headers"
          :rows-per-page-items="pagination.rowsPerPageItems"
          rows-per-page-text="Mostrar"
          align-center
          justify-center
          :items="approaches.objects"
          :total-items="totalItems"
          :pagination.sync="pagination"
          no-data-text="Nenhuma abordagem para este credor"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top dark>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span v-if="props.header.tooltip">{{ props.header.tooltip }}</span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="{ item }">
            <tr :style="`${item.active ? '' : 'opacity:.5;'}`">
              <td>{{ item.creditor ? item.creditor.name : "" }}</td>
              <td style="font-weight: 400">
                <span :class="`tag-approach-type small ${item.type}`">{{ item.type }}</span>
                {{ item.name + " " }}
              </td>
              <td>
                {{ item.notify_type == "SEQUENTIAL" ? "Sequencial" : " Aleatória" }}
              </td>

              <td>{{ formatApproach(item) }}</td>

              <td>{{ item.uses }}{{ item.uses == 1 ? " estratégia" : " estratégias" }}</td>
              <td>{{ item.updated_at | formatDateTime }}</td>
              <td class="text-xs-center pa-0">
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="editApproach(item)">
                      <v-list-tile-title>Editar</v-list-tile-title>
                    </v-list-tile>
                    <!-- <v-list-tile
                                            :disabled="item.strategies.length > 0"
                                            @click="deleteApproach(item.id,item.name)"
                                        >
                                            <v-list-tile-title>Excluir</v-list-tile-title>
                                        </v-list-tile> -->
                    <v-list-tile @click="updateStatus(item)">
                      <v-list-tile-title>{{
                        !item.active ? "Ativar" : "Desativar"
                      }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"></v-progress-circular>
                <strong v-else class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhuma abordagem encontrada</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
      <v-btn color="accent" fixed bottom right fab @click="dialogNewApproach = true">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog scrollable v-model="dialogNewApproach" width="550">
      <v-card>
        <v-card-title class="headline" primary-title>Nova abordagem</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-form ref="form" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 md7>
                  <v-text-field
                    box
                    required
                    label="Nome"
                    :rules="[(v) => !!v || 'O nome é obrigatório!']"
                    v-model="newApproach.name"></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-select
                    box
                    required
                    clearable
                    label="Tipo"
                    item-text="name"
                    item-value="value"
                    :items="approachType"
                    :rules="[(v) => !!v || 'O tipo da abordagem é obrigatório!']"
                    v-model="newApproach.type"></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    box
                    clearable
                    label="Credor"
                    item-text="name"
                    item-value="creditor_id"
                    :items="creditors.objects"
                    :rules="[(v) => !!v || 'O credor é obrigatório!']"
                    v-model="newApproach.creditor_id"></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    box
                    clearable
                    item-text="name"
                    item-value="value"
                    label="Tipo de notificação"
                    :items="notifyTypes"
                    :rules="[(v) => !!v || 'O tipo de notificação é obrigatório!']"
                    v-model="newApproach.notify_type">
                    <v-tooltip top slot="prepend-inner">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="pr-1"
                          style="font-size: 18px; cursor: help; height: 24px; width: 24px"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <ul>
                        <li>
                          <b>Sequencial:</b> Cada contato recebe a mensagem seguinte da abordagem
                          (padrão)
                        </li>
                        <li>
                          <b>Aleatória:</b> As mensagens são distribuídas de forma aleatória entre
                          os contatos
                        </li>
                      </ul>
                    </v-tooltip>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="dialogNewApproach = false"> Fechar </v-btn>
          <v-btn class="elevation-0" color="primary" @click="addApproach"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import store from "@/store";
import approachService from "@/services/approach";
import approachType from "@/utils/approach-type";
import creditorService from "@/services/creditor";
import SelectCreditors from "@/components/creditor/SelectCreditors";

export default {
  components: {
    SelectCreditors,
  },
  data() {
    return {
      active: true,
      fab: false,
      dialog: false,
      loading: false,
      doneFetching: false,
      dialogNewApproach: false,
      approach_name: "",
      totalItems: 0,
      selectedCreditor: 0,
      nameFilter: null,
      approach_id: null,
      approachType: [],
      approachsTypes: [],
      selectedApproachTypes: [],
      query: {},
      creditors: {},
      newApproach: {
        active: true,
        name: "",
        type: "",
        creditor_id: "",
        notify_type: "",
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "updated_at",
        rowsPerPageItems: [10, 25, 50, 100],
      },
      approaches: {
        objects: [],
      },
      notifyTypes: [
        { value: "SEQUENTIAL", name: "Sequencial" },
        { value: "RANDOM", name: "Aleatória" },
      ],
      headers: [
        {
          text: "Credor",
          align: "left",
          value: "creditor.name",
          tooltip: "Nome do credor",
          width: "10%",
        },
        {
          text: "Abordagem",
          align: "left",
          value: "name",
          tooltip: "Titulo da abordagem",
          width: "20%",
        },
        {
          text: "Tipo",
          align: "left",
          tooltip: "Modo como as mensagens da abordagem são enviadas",
          value: "notify_type",
          width: "10%",
        },
        {
          text: "Tamanho",
          align: "left",
          tooltip: "Quantidade de mensagens na abordagem",
          value: "notify_type",
          width: "10%",
        },
        {
          text: "Utilização",
          align: "left",
          value: "uses",
          width: "10%",
          sortable: true,
        },
        {
          text: "Atualização",
          align: "left",
          value: "updated_at",
          width: "10%",
        },
        {
          text: "Ações",
          align: "center",
          value: "",
          sortable: false,
          width: "2%",
        },
      ],
    };
  },
  async created() {
    await this.getCreditors();

    this.approachType = approachType.approachType.filter(
      (item) => item.value === "SMS" || item.value === "PUSH"
    );
    this.approachsTypes = approachType.approachType
      .filter((item) => item.value === "SMS" || item.value === "PUSH")
      .map((e) => e.value);

    this.query = this.$route.query;
    if (this.query && Object.keys(this.query).length == 0) {
      this.query = store.getters.getManualStrategy;
    }
    if (this.query) {
      if (this.query.sortBy) this.pagination.sortBy = this.query.sortBy;
      if (this.query.descending) this.pagination.descending = this.query.descending;
      if (this.query.rowsPerPage) this.pagination.rowsPerPage = this.query.rowsPerPage;
      if (this.query.page) this.pagination.page = this.query.page;
      if (this.query.nameFilter && this.query.nameFilter.length)
        this.nameFilter = this.query.nameFilter;
      if (this.query.types) {
        this.query.types.split(",").forEach((id) => {
          this.selectedApproachTypes.push(id);
        });
      } else {
        this.approachsTypes.forEach((id) => {
          this.selectedApproachTypes.push(id);
        });
      }
      if (this.query.approachTypes) {
        this.query.approachTypes.split(",").forEach((id) => {
          this.selectedApproachTypes.push(id);
        });
      }
      if (this.query.creditors) {
        this.query.creditors.split(",").forEach((id) => {
          this.selectedCreditor = parseInt(id);
        });
      }

      if (this.query && this.query.active) {
        if (typeof this.query.active == "string") {
          this.active = JSON.parse(this.query.active.toLowerCase());
        } else {
          this.active = this.query.active;
        }
      }
      if (this.query.descending) {
        if (typeof this.query.descending == "string") {
          this.descending = JSON.parse(this.query.descending.toLowerCase());
        } else {
          this.descending = this.query.descending;
        }
      }
      if (this.query.creditor) {
        this.selectedCreditor = parseInt(this.query.creditor);
        this.query.creditor = this.selectedCreditor;
      }
    }
    await this.searchApproach();
    this.query.active = this.active;
    this.doneFetching = true;
  },
  watch: {
    pagination: {
      async handler() {
        if (this.doneFetching) {
          this.addfilters();

          await this.searchApproach();
        }
      },
      deep: true,
    },
    dialogNewApproach() {
      if (!this.dialogNewApproach) {
        this.newApproach = {
          active: true,
          name: "",
          type: "",
          creditor_id: "",
          notify_type: "",
        };
        this.$refs.form.reset();
      }
    },
  },
  methods: {
    changeSelectCreditors(event) {
      this.selectedCreditor = event;
      this.searchApproach();
    },
    async updateStatus(approach) {
      let approachToSave = {
        active: !approach.active,
        id: approach.id,
      };

      await approachService
        .save(approachToSave)
        .then(async (res) => {
          let message = "";
          approach.active = res.active;

          message = approach.active
            ? `Abordagem ${approach.name} ativada!`
            : `Abordagem ${approach.name} desativada!`;
          this.$store.commit("showSnackbar", {
            message,
            important: true,
          });
          this.searchApproach();
          if (res == undefined) {
            this.$store.commit("showSnackbar", "Houve um erro ao salvar");
            return console.error("houve um erro");
          }
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", "Houve um erro ao salvar");
          console.error("Houve um erro", error);
        });
    },
    async searchApproach() {
      this.addfilters();

      if (this.loading) return;
      this.loading = true;

      await approachService
        .list(
          this.selectedCreditor,
          this.pagination,
          this.active,
          this.selectedApproachTypes.length ? this.selectedApproachTypes : ["SMS", "PUSH "],
          this.nameFilter
        )
        .then((res) => {
          this.approaches = res;
          this.totalItems = res.num_results;
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addfilters() {
      this.query = {};
      this.query.rowsPerPage = this.pagination.rowsPerPage;
      this.query.page = this.pagination.page;
      if (this.pagination.descending) this.query.descending = this.pagination.descending;
      if (this.pagination.sortBy) this.query.sortBy = this.pagination.sortBy;
      else this.query.sortBy = 0;
      if (this.selectedCreditor > 0) this.query.creditor = this.selectedCreditor;
      this.$store.commit("setManualStrategy", this.query);
      if (this.selectedApproachTypes.length > 0)
        this.query.types = this.selectedApproachTypes.map((sp) => sp).join(",");
      this.query.active = this.active;
      if (this.nameFilter && this.nameFilter.length) this.query.nameFilter = this.nameFilter;
      this.$store.commit("setManualStrategy", this.query);
      if (this.$route.path == "/approaches") {
        this.$router.replace({
          name: "Abordagens",
          query: this.query,
        });
      }
    },
    addApproach() {
      if (!this.$refs.form.validate()) return;
      this.searchApproach();
      approachService
        .save(this.newApproach)
        .then((res) => {
          this.$router.push({
            name: "Abordagem",
            params: {
              edit: true,
              approach_id: res.id,
            },
          });
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
        });
    },
    editApproach(approach) {
      this.$router.push({
        name: "Abordagem",
        params: {
          edit: true,
          approach_id: approach.id,
        },
      });
    },
    formatApproach(item) {
      let messages = item.messages || [];
      let messagesLength = messages.length;

      return messagesLength <= 1 ? messagesLength + " mensagem" : messagesLength + " mensagens";
    },
    async updateObjectList(id, list) {
      return list.filter(function (e) {
        return e.id !== id;
      });
    },
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => {
          this.creditors = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style>
.v-datatable__actions__range-controls {
  margin-right: 8%;
}
</style>
